import { ErrorWrapper } from "@origin-digital/error-wrapper";
import React from "react";
import { logger } from "@origin-digital/reporting-client";
import { content } from "../../content";
import styled from "styled-components";

interface ErrorBoundaryProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

const ErrorWrapperContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.background.paper} !important;
  padding: 48px 0;
`;

export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    logger.error("ErrorBoundary caught an error:", error);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }
      return (
        <ErrorWrapperContainer>
          <ErrorWrapper
            header={content.errorBoundary.header}
            body={<p>{content.errorBoundary.body}</p>}
            buttonLabel={content.errorBoundary.buttonLabel}
            onClick={() => window.location.reload()}
          />
        </ErrorWrapperContainer>
      );
    }
    return this.props.children;
  }
}
